// The banner built into the customer home page of some themes ("MEGA DEALS" on
// Zepto, "Lowest Prices Everyday" on Instamart, which Modern Organic also uses).
// The store admin can hide it or change its text (Admin → Settings → Home Page
// Banner). Until the admin saves it, the theme's own wording is shown. Once
// saved, an empty title still falls back to the theme's title (a banner needs
// one), while an empty subtitle or badge is simply not shown.

export const HOME_BANNER_LIMITS = { title: 40, subtitle: 80, badge: 30 };

const ZEPTO = { title: 'MEGA DEALS', subtitle: 'Save big on essentials', badge: 'Up to 50% OFF' };
const INSTAMART = { title: 'Lowest Prices Everyday', subtitle: 'Fresh groceries at unbeatable prices', badge: '' };

// Theme → its built-in banner text. Themes not listed (Blinkit, Country) have
// no built-in banner.
const THEME_DEFAULTS = {
  'theme-zepto': ZEPTO,
  'theme-instamart': INSTAMART,
  'theme-modern-organic': INSTAMART, // renders the Instamart home
};

export const themeHomeBannerDefaults = (theme) => THEME_DEFAULTS[theme] || null;

const clean = (value) => (typeof value === 'string' ? value.trim() : '');

// What the home page should show, or null when the banner is hidden. A store
// that never touched the setting gets the theme's banner, exactly as before.
export const resolveHomeBanner = (homeBanner, defaults) => {
  if (!defaults) return null;
  if (!homeBanner) return { ...defaults, customTitle: false };
  if (homeBanner.is_active === false) return null;
  const title = clean(homeBanner.title) || defaults.title;
  return {
    title,
    subtitle: clean(homeBanner.subtitle),
    badge: clean(homeBanner.badge),
    customTitle: title !== defaults.title,
  };
};

// Where the admin form starts when the store has never saved the banner: the
// text customers see right now.
export const initialHomeBanner = (defaults) => ({
  is_active: true,
  title: defaults?.title || '',
  subtitle: defaults?.subtitle || '',
  badge: defaults?.badge || '',
});
